import { FC } from 'react';
import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import { useTranslation } from 'react-i18next';
import { Alert, Skeleton } from '@mui/material';
import BackButton from '@/components/ui/BackButton/BackButton.tsx';
import { useParams } from 'react-router-dom';
import RouteParam from '@/_constants/RouteParam.ts';
import useCallLogs from '@/api/useCallLogs.ts';
import ReservationLogsTable from '@/components/functional/ReservationLogsTable/ReservationLogsTable.tsx';

const RestaurantReservationLogs: FC = () => {
  const { t } = useTranslation();
  const routeParams = useParams();
  const reservationId = parseInt(routeParams[RouteParam.RESERVATION_ID]!);
  const {
    data: callLogs,
    isLoading: isLoadingCallLogs,
    isError: isErrorCallLogs,
    error: errorCallLogs,
  } = useCallLogs(true, {
    reservation_id: reservationId,
  });

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap gap-4">
        <BackButton />
        {isLoadingCallLogs ? (
          <Skeleton variant="text" width={200} />
        ) : callLogs && callLogs[0]?.reservation_id?.client ? (
          <h1 className="text-3xl font-medium m-0 font-ubuntu">
            {callLogs[0]?.reservation_id?.client}{' '}
            {callLogs[0]?.reservation_id?.phone ? (
              <span className="text-text-secondary">({callLogs[0]?.reservation_id?.phone})</span>
            ) : null}
          </h1>
        ) : (
          <h1 className="text-3xl font-medium m-0 font-ubuntu">{t('pages.restaurantReservationsLogs.title')}</h1>
        )}
      </div>
      {isErrorCallLogs && <Alert severity="error">{errorCallLogs?.message}</Alert>}
      <div>
        <LoaderWrapper isLoading={isLoadingCallLogs}>
          <ReservationLogsTable rows={callLogs ?? []} />
        </LoaderWrapper>
      </div>
    </div>
  );
};

export default RestaurantReservationLogs;
